// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import vuetify from '@/plugins/vuetify' // path to vuetify export

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Sentry.init({
  Vue: Vue,
  dsn: process.env.SENTRY_DSN,
  environment: process.env.NODE_ENV,
  debug: process.env.MODE_DEBUG === true,
  release: 'agendaDiaria@' + process.env.npm_package_version,
  integrations: [new Integrations.BrowserTracing()],
  tracingOptions: {
    trackComponents: true
  },
  logErrors: false,
  autoSessionTracking: false, // default: true
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js